<script>
// Despliegue de los árboles de cuentas que devuelven los reportes contables
// (backend: ReportesContablesController::buildCuentasTree). Cada nodo trae
// account_id, code, name, label, importe, children[] y conceptos[].
//
// La vista que lo use debe definir la computed `cuentasTrees`: un array con los
// árboles a considerar (uno por grupo/sección), sobre el que operan `allExpanded`
// y "Expandir todo".
export default {
  name: "CuentasTreeMixin",
  data() {
    return {
      expanded: {},
    };
  },
  computed: {
    allExpanded() {
      const ids = this.collectAllTogglableIds();
      return ids.length > 0 && ids.every((id) => this.expanded[id]);
    },
  },
  methods: {
    // Aplana un árbol de cuentas en filas { item, depth, hasChildren, hasConceptos, expanded },
    // insertando las hijas de cada cuenta expandida justo después de ella.
    flattenCuentas(nodes, depth = 0) {
      const rows = [];
      nodes.forEach((item) => {
        const hasChildren = item.children && item.children.length > 0;
        const hasConceptos = item.conceptos && item.conceptos.length > 0;
        const expanded = (hasChildren || hasConceptos) && !!this.expanded[item.account_id];
        rows.push({ item, depth, hasChildren, hasConceptos, expanded });
        if (hasChildren && expanded) rows.push(...this.flattenCuentas(item.children, depth + 1));
      });
      return rows;
    },
    // account_id de toda cuenta desplegable (con hijas y/o apertura por concepto), en todos los niveles.
    collectTogglableIds(nodes) {
      const ids = [];
      nodes.forEach((item) => {
        const hasChildren = item.children && item.children.length > 0;
        const hasConceptos = item.conceptos && item.conceptos.length > 0;
        if (hasChildren || hasConceptos) ids.push(item.account_id);
        if (hasChildren) ids.push(...this.collectTogglableIds(item.children));
      });
      return ids;
    },
    collectAllTogglableIds() {
      const ids = [];
      (this.cuentasTrees || []).forEach((nodes) => ids.push(...this.collectTogglableIds(nodes)));
      return ids;
    },
    toggle(account_id) {
      this.$set(this.expanded, account_id, !this.expanded[account_id]);
    },
    toggleAll() {
      const value = !this.allExpanded;
      const expanded = {};
      this.collectAllTogglableIds().forEach((id) => (expanded[id] = value));
      this.expanded = expanded;
    },
    resetExpanded() {
      this.expanded = {};
    },
  },
};
</script>
